var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBreathehr = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6571 39.2759C36.1481 34.0958 40.7908 30.4714 46.1913 30.4714C51.6375 30.4714 56.313 34.1579 57.7616 39.4084C59.2642 39.6538 60.6672 40.1851 61.9249 40.9375C62.6779 39.0451 63.0953 36.9763 63.0953 34.8078C63.0953 26.0904 56.3914 18.9929 47.9694 18.5606C46.6967 10.8669 40.1647 5 32.2768 5C24.3902 5 17.8609 10.8627 16.5848 18.5522C16.3672 18.5431 16.1551 18.5173 15.9348 18.5173C7.13359 18.5173 0 25.8122 0 34.8078C0 43.8054 7.13359 51.1002 15.9348 51.1002H23.5731C23.7941 44.8394 28.5978 39.7535 34.6571 39.2759Z",
    fill: "#003E51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.253 43.083L54.6371 42.9997L54.3672 41.3505C53.7023 37.2829 50.3227 34.3301 46.332 34.3301C42.3433 34.3301 38.9638 37.2808 38.2969 41.3456L38 43.1566L36.2129 43.0775C36.2129 43.0775 35.9254 43.0581 35.8952 43.0581C31.3941 43.0581 27.7332 46.8417 27.7332 51.4931C27.7332 56.1452 31.3941 59.9302 35.8952 59.9302H55.8386C60.3384 59.9302 64 56.1452 64 51.4931C64 47.0028 60.597 43.3086 56.253 43.083Z",
    fill: "#0580FA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBreathehr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/breathehr.81a34277a03f12e258bbfb85d4634075.svg";